import type { useHistory } from 'react-router-dom';
import type {
  UpdateSalaryRequest,
  UpdateSignOnBonusRequest,
} from '@applied/proto/web_services/candidate_experience/proto/web_offer_pb';
import type { GenericResponse, ResponseData } from 'api/http_requests';
import { makeAuthenticatedRequest, postData } from 'api/http_requests';

export async function updateSalarySubdivisions(
  history: ReturnType<typeof useHistory>,
  salarySubdivisions: number,
  candidateEmail?: string,
): Promise<ResponseData<GenericResponse> | null> {
  const payload: UpdateSalaryRequest = {
    salarySubdivisions: BigInt(salarySubdivisions),
  };
  const response = await makeAuthenticatedRequest(
    () =>
      postData(
        candidateEmail
          ? `/api/web_offer/${candidateEmail}/update_salary_subdivisions`
          : '/api/web_offer/update_salary_subdivisions',
        payload,
      ),
    history,
  );
  return response;
}

export async function updateSignOnBonusSubdivisions(
  history: ReturnType<typeof useHistory>,
  signOnBonusSubdivisions: number,
  candidateEmail?: string,
): Promise<ResponseData<GenericResponse> | null> {
  const payload: UpdateSignOnBonusRequest = {
    signOnBonusSubdivisions: BigInt(signOnBonusSubdivisions),
  };
  const response = await makeAuthenticatedRequest(
    () =>
      postData(
        candidateEmail
          ? `/api/web_offer/${candidateEmail}/update_sign_on_bonus_subdivisions`
          : '/api/web_offer/update_sign_on_bonus_subdivisions',
        payload,
      ),
    history,
  );
  return response;
}
